import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import {
  PlanListPage,
  PlanEditPage,
  PlanCreatePage,
  PlanInformationPage,
  PlanSubscriptionPage,
} from './imports';

export const planRoutes = [
  {
    path: 'plans',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PLAN}
            access={OrionAccess.VIEW}
          >
            <PlanListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PLAN}
            access={OrionAccess.VIEW}
          >
            <PlanListPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PLAN}
            access={OrionAccess.CREATE}
          >
            <PlanCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PLAN}
            access={OrionAccess.UPDATE}
          >
            <PlanEditPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/information',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.PLAN}
            access={OrionAccess.VIEW}
          >
            <PlanInformationPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/subscription',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.SUBSCRIPTION}
            access={OrionAccess.VIEW}
          >
            <PlanSubscriptionPage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
